import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ChevronDown, ChevronUp, User, Box, Package,
  FileText, MapPin, LogOut
} from "lucide-react";

import {
  getIncidenteById, getTipoUbicacionById, getProductoById,  getMaterialById,
  getMarcaById, getFamiliaById, getEmpleadoByUserId,
  getUbicacionById, getTicketById //getKitById
} from "../api";

import FilterTableValeNuevo from "./FilterTableValeNuevo";
import FilterTableTicket from "./FilterTableTicket";
import FilterTableIncidente from "../components/FilterTableIncidente";
import FilterTableTipoUbicacion from "../components/FilterTableTipoUbicacion";
import FilterTableProducto from "../components/FilterTableProducto";
import FilterTableMaterial from "../components/FilterTableMaterial";
import FilterTableMarca from "../components/FilterTableMarca";
import FilterTableFamilia from "../components/FilterTableFamilia";
import FilterTableUbicacion from "../components/FilterTableUbicacion";
import FilterTableGestionUsuarios from "../components/FilterTableGestionUsuarios";
import ReporteEspecificoProductos from "./ReporteEspecificoProductos";
import ReporteEspecificoEmpleado from "./ReporteEspecificoEmpleado";
import ReporteActualProductos from "./ReporteActualProductos";
import NuevoCatalogo from "./NuevoCatalogo";
import CambiarContrasena from "./CambiarContrasena";

const menuOptions = [
  { id: "almacen", label: "Almacen >", icon: <Box size={20} />, submenu:[
    { id: "vale-nuevo", label: "Vale Nuevo", icon: <Box size={20} /> },
    { id: "producto", label: "Productos", icon: <Box size={20} /> },
    ]
  },
  { id: "incidente", label: "Incidentes", icon: <FileText size={20} /> },
  { id: "reportes", label: "Reportes >", icon: <Box size={20} />, submenu:[
    { id: "reporte_especifico", label: "Reportes Historicos", icon: <Box size={20} /> },
    { id: "reporte_actual", label: "Reporte Actual", icon: <Box size={20} /> },
    { id: "nuevo_catalogo", label: "Resumen Almacen", icon: <Box size={20} /> },
    { id: "reporte_empleado", label: "Reporte Especifico Empleado", icon: <Box size={20} /> },
    ]
  },
  { id: "configuracion", label: "Configuracion >", icon: <Box size={20} />, submenu:[
    { id: "cambiar_contrasena", label: "Cambiar contraseña", icon: <User size={20} /> },
    { id: "material", label: "Materiales", icon: <Box size={20} /> },
    { id: "marca", label: "Marcas", icon: <Package size={20} /> },
    { id: "familia", label: "Familias", icon: <Package size={20} /> },
    { id: "ubicacion", label: "Ubicaciones", icon: <MapPin size={20} /> },
    { id: "tipo_ubicacion", label: "Tipo Ubicación", icon: <MapPin size={20} /> },
    ]
  },
  { id: "ticket", label: "Ayuda", icon: <Box size={20} /> },
];

const Almacen = () => {
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = location.state || {};
  const [entities, setEntities] = useState({});
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [selectedSection, setSelectedSection] = useState("producto"); //pagina inicial depende de tipo de usuario

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const loadData = useCallback(async (entity, apiCall) => {
    try {
      const { data } = await apiCall();
      setEntities(prev => ({ ...prev, [entity]: data }));
    } catch (error) {
      console.error(`Error loading ${entity}:`, error);
    }
  }, []);

  useEffect(() => {
    if (userData) {
      loadData("empleado", () => getEmpleadoByUserId(userData[0].id_usuario));
      loadData("incidente", getIncidenteById);
      loadData("tipo_ubicacion", getTipoUbicacionById);
      loadData("producto", getProductoById);
      loadData("material", getMaterialById);
      loadData("marca", getMarcaById);
      loadData("familia", getFamiliaById);
      loadData("ubicacion", getUbicacionById);
      loadData("ticket", getTicketById);
      setLoading(false);
    }
  }, [loadData, userData]);

  const handleMenuClick = (id, hasSubmenu) => {
    if (hasSubmenu) {
      setOpenSubmenu(openSubmenu === id ? null : id);
    } else {
      setSelectedSection(id);
      setOpenSubmenu(null);
    }
  };

  const renderSection = () => {
    return (
      <div className="admin-sections">
        {/* Gestion Usuarios Section */}
        <div style={{ display: selectedSection === "gestion_usuarios" ? "block" : "none" }}>
          <FilterTableGestionUsuarios />
        </div>
  
        {/* Incidente Section */}
        <div style={{ display: selectedSection === "incidente" ? "block" : "none" }}>
          <FilterTableIncidente />
        </div>
  
        {/* Producto Section */}
        <div style={{ display: selectedSection === "producto" ? "block" : "none" }}>
          {entities.empleado ? (
            <FilterTableProducto empleado={entities.empleado[0]} />
          ) : (
            <div>Cargando datos del empleado...</div>
          )}
        </div>
  
        {/* Vale Nuevo Section */}
        <div style={{ display: selectedSection === "vale-nuevo" ? "block" : "none" }}>
          <FilterTableValeNuevo />
        </div>
  
        {/* Material Section */}
        <div style={{ display: selectedSection === "material" ? "block" : "none" }}>
          <FilterTableMaterial />
        </div>
  
        {/* Marca Section */}
        <div style={{ display: selectedSection === "marca" ? "block" : "none" }}>
          <FilterTableMarca />
        </div>
  
        {/* Familia Section */}
        <div style={{ display: selectedSection === "familia" ? "block" : "none" }}>
          <FilterTableFamilia />
        </div>
  
        {/* Ubicacion Section */}
        <div style={{ display: selectedSection === "ubicacion" ? "block" : "none" }}>
          <FilterTableUbicacion />
        </div>
  
        {/* Tipo Ubicacion Section */}
        <div style={{ display: selectedSection === "tipo_ubicacion" ? "block" : "none" }}>
          <FilterTableTipoUbicacion />
        </div>

        <div style={{ display: selectedSection === "cambiar_contrasena" ? "block" : "none" }}>
          <CambiarContrasena />
        </div>

        {/* Ticket Section */}
        <div style={{ display: selectedSection === "ticket" ? "block" : "none" }}>
          <FilterTableTicket />
        </div>

        {/* Dashboards Section */}
        <div style={{ display: selectedSection === "reporte_especifico" ? "block" : "none" }}>
          <ReporteEspecificoProductos />
        </div>

        <div style={{ display: selectedSection === "reporte_actual" ? "block" : "none" }}>
          <ReporteActualProductos />
        </div>

        <div style={{ display: selectedSection === "nuevo_catalogo" ? "block" : "none" }}>
          <NuevoCatalogo />
        </div>

        <div style={{ display: selectedSection === "reporte_empleado" ? "block" : "none" }}>
          <ReporteEspecificoEmpleado />
        </div>

      </div>
    );
  };
  
  return (
    <div>
      {loading ? (
        <div className="loader"></div>
      ) : (
        <div className="container-principal">
          {/* Menu lateral */}
          <div className={`menu-bar ${isMenuOpen ? "expanded" : "collapsed"}`}>
          <img
              className="img-banner"
              alt="Adser consorcio"
              src={isMenuOpen ? "/adser_logo_bn.png" : "/adser_logo_collapsed.png"}
              width="150"
              height="40"
            />

            <button className="toggle-menu" onClick={toggleMenu}>
              {isMenuOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>

            <div className="menu-content">
              {menuOptions.map(({ id, label, icon, submenu }) => (
                <div key={id}>
                  <button
                    className="menu-button"
                    onClick={() => handleMenuClick(id, !!submenu)}
                  >
                    {isMenuOpen ? label : icon}
                  </button>

                  {submenu && openSubmenu === id && (
                    <div className="submenu">
                      {submenu.map(({ id: subId, label: subLabel, icon: subIcon }) => (
                        <button
                          key={subId}
                          className="submenu-button"
                          onClick={() => setSelectedSection(subId)}
                        >
                          {isMenuOpen ? subLabel : subIcon}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              <button className="menu-button" onClick={() => navigate("/")}>
                {isMenuOpen ? "Salir" : <LogOut size={20} />}
              </button>
            </div>
          </div>

          {/* Contenido principal */}
          <div>{renderSection()}</div>
        </div>
      )}
    </div>
  );
};

export default Almacen;
